export const blogData = [
    // {
    //     id: 1,
    //     title: 'SCRAPING BILLBOARD AND IMDB USING PYTHON SELENIUM',
    //     description: 'Here we will use Selenium to navigate between web pages, and try to scrape data from them.',
    //     date: 'Aug 7, 2020',
    //     image: 'https://1.bp.blogspot.com/-6vZQoWcIZeo/Xvw5ZD5Y53I/AAAAAAAABgI/GH2b5OuMaXAKuigK4diBbeYDW6dD3qVvgCK4BGAsYHg/w400-h225/selenium.jpg',
    //     url: 'https://hackzism.blogspot.com/2020/07/scraping-billboard-and-imdb-using.html'
    // },
    

]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/